import React, { useState } from 'react';
import './Tab.css'; // You'll need some CSS for styling
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../routes/PathLink';
import { Table } from "../components/ui/table";
import Breadcrumb  from "../components/Breadcrumb";

import {
  useIpoQuery
} from '../data/ipos';
import { amount_format} from "../components/config/Common";
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'

const Ipo = () => {

  const [metaTitle, setMetaTitle] = useState('All Indian IPOs - NSE & BSE IPO List (Upcoming, Live & Listed)')
    const [metaDesc, setMetaDesc] = useState('Explore the Indian IPO list covering NSE & BSE IPOs with upcoming issues, company details, issue size, price band, and listing performance updates.')

    const [activeTab, setActiveTab] = useState('listed'); // State to track the active tab

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };


const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`IPO`,
    link:null
  }
]

    const {
        upcoming,
        listed,
        active,
        closed,
        isLoading,
        error,
    } = useIpoQuery();

    //console.log('upcoming===',upcoming)

    const DateDisplay = ({ dbDateString }) => {
        if(!dbDateString){
            return null
        }
        // 1. Create a JavaScript Date object from the DB date string (usually ISO format)
        const dateObj = new Date(dbDateString);

        // 2. Use toLocaleString() with options to format it
        const formattedDate = dateObj.toLocaleString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',    
            
        });

        return <p>{formattedDate}</p>;
        };

    const columns = [
        {
          title: 'Sr.No.',
          dataIndex: 'srno',
          key: 'id',
          align: 'left',
          width: 5,
          render: (text, record, index) => {
                return index+1
                
            },
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          align: 'left',
          width: 200,
          render:(name, record) =>(
            <>
            {upcoming && record.symbol ?
            <Link className="text-accent hover:underline" to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${record.symbol}`}>{name}</Link>
            :(<span>{name}</span>)
            }
            </>
            )
        },
        
        {
          title: 'Issue Price',
          dataIndex: 'issue_price',
          key: 'issue_price',
          align: 'left',
          width: 200,
          render:(issue_price) =>(
            <>
            {upcoming &&
            <div>{amount_format(issue_price)}</div>
            }
            </>
            )
        },
        {
          title: 'Listing price',
          dataIndex: 'listing_price',
          key: 'listing_price',
          align: 'left',
          width: 200,
          render:(listing_price) =>(
            <>
            {upcoming &&
            <div>{amount_format(listing_price)}</div>
            }
            </>
            )
        },
        {
          title: 'Listing Gains',
          dataIndex: 'listing_gains',
          key: 'listing_gains',
          align: 'left',
          width: 200,
          render:(listing_gains) =>(
            <>
            {upcoming &&
            <div className={listing_gains < 0 ? 'text-red-500' :listing_gains > 0 && 'text-green-500'}>{listing_gains?.toFixed(2)}{listing_gains ? <>%</>:null}</div>
            }
            </>
            )
        },
        {
          title: 'Start date',
          dataIndex: 'bidding_start_date',
          key: 'bidding_start_date',
          align: 'left',
          width: 200,
          render:(bidding_start_date) =>(
            <>
            {upcoming &&
            <DateDisplay dbDateString={bidding_start_date} />

            }
            </>
            )
        },
        
        {
          title: 'Listing date',
          dataIndex: 'listing_date',
          key: 'listing_date',
          align: 'left',
          width: 200,
          render:(listing_date) =>(
            <>
            {upcoming &&
            <DateDisplay dbDateString={listing_date} />
            }
            </>
            )
        },
        {
          title: 'Lot Size',
          dataIndex: 'lot_size',
          key: 'lot_size',
          align: 'left',
          width: 200,
          render:(lot_size) =>(
            <>
            {upcoming &&
            <div>{lot_size}</div>

            }
            </>
            )
        },
    ]

  return (
    <>
    <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/ipo`}
      />  
    <Header  />
        <div className="space-y-5 px-5 lg:px-8">
        <Breadcrumb breadcrumb={breadcrumb} />
    <section className="bg-white shadow-sm z-50 rounded-xl p-5">
        <h2 className="text-2xl px-6 mb-5">IPOs</h2>
        <p className='px-6'>Explore IPOs with detailed issue information, company profiles, and listing performance across NSE & BSE.</p>
        <div className="w-full px-6">
        {/* Tab Navigation */}
        <div className="tab-list">
            <button
            id="listed"
            onClick={() => handleTabClick('listed')}
            className={activeTab === 'listed' ? 'active-tab' : ''}
            >
            Listed
            </button>
            <button
            id="upcoming"
            onClick={() => handleTabClick('upcoming')}
            className={activeTab === 'upcoming' ? 'active-tab' : ''}
            >
            Upcoming
            </button>
            
            <button
            id="active"
            onClick={() => handleTabClick('active')}
            className={activeTab === 'active' ? 'active-tab' : ''}
            >
            Active
            </button>
            <button
            id="closed"
            onClick={() => handleTabClick('closed')}
            className={activeTab === 'closed' ? 'active-tab' : ''}
            >
            Closed
            </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
            {activeTab === 'upcoming' && 
                <>{upcoming && <Table
                    //@ts-ignore
                    columns={columns}
                    rowKey="id"
                    data={upcoming}
                    scroll={{ x: 900 }}
                  />}

                  </>
            }
            {activeTab === 'listed' && 
                <>{listed && <Table
                    //@ts-ignore
                    columns={columns}
                    rowKey="id"
                    data={listed}
                    scroll={{ x: 900 }}
                  />}

                  </>
            }
            {activeTab === 'active' && 
                <>{active && <Table
                    //@ts-ignore
                    columns={columns}
                    rowKey="id"
                    data={active}
                    scroll={{ x: 900 }}
                  />}

                  </>
            }
            {activeTab === 'closed' && 
                <>{closed && <Table
                    //@ts-ignore
                    columns={columns}
                    rowKey="id"
                    data={closed}
                    scroll={{ x: 900 }}
                  />}

                  </>
            }
        </div>
        </div>
    </section>
    </div>
    <Footer />
    </>
  );
}
export default Ipo;